const my_profile = {
  viewMyClubSeacretProfile: "Visualizza il profilo di My ClubSecret", // translated
  unverifiedEmail: "E-mail non verificata", // translated
  verifiedEmail: "E-mail verificata", // translated
  viewMoreDetails: "Visualizza ulteriori dettagli", // translated
};

export default my_profile;
